import React, { useEffect, useState, useContext, createContext } from 'react';
import { motion } from 'framer-motion';
import { fetchEmotii } from '../api/api';
import SectionContainer from './sectioncontainer';
import { trackEvent } from '../services/analytics';
import { saveEmotionSelection } from '../services/emotionSelections';

// ✅ Context pentru beneficii
const BeneficiiContext = createContext();
export const useBeneficii = () => useContext(BeneficiiContext);

export const BeneficiiProvider = ({ children }) => {
  const [beneficiiMap, setBeneficiiMap] = useState({});

  useEffect(() => {
    import('../api/api').then(({ fetchBeneficii }) => {
      fetchBeneficii().then((beneficii) => {
        const map = {};
        beneficii.forEach((b) => {
          map[b.id] = b.nume;
        });
        setBeneficiiMap(map);
      });
    });
  }, []);

  return (
    <BeneficiiContext.Provider value={beneficiiMap}>
      {children}
    </BeneficiiContext.Provider>
  );
};

// ✅ Componenta principală
const CumTeSimtiAzi = ({ onEmotieSelect }) => {
  const [emotii, setEmotii] = useState([]);

  useEffect(() => {
    fetchEmotii()
      .then(setEmotii)
      .catch((err) => console.error("Eroare la fetchEmotii:", err));
  }, []);

  const handleEmotieClick = (emotie) => {
    trackEvent('emotion_opened', { emotion_id: emotie.id, source: 'cumtesimtiazi' });
    saveEmotionSelection(emotie.id, 'cumtesimtiazi');

    if (onEmotieSelect) {
      onEmotieSelect(emotie.id);
    }
  };

  return (
    <SectionContainer
      title={
        <h2 className="text-text-primary font-poppins text-xl md:text-2xl font-semibold tracking-tight relative z-10">
          Ce simți, cu adevărat, acum?
        </h2>
      }
      dividerTop
    >
      <div className="relative">
        <div className="flex justify-center relative z-10">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-4 w-full max-w-3xl">
            {emotii.slice(0, 6).map((emotie) => (
              <motion.button
                key={emotie.id}
                onClick={() => handleEmotieClick(emotie)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="relative w-full h-[60px] flex items-center justify-center rounded-2xl px-3 py-2 text-white font-poppins text-sm font-semibold text-center transition overflow-hidden shadow-level1 border border-accent/30"
                style={{
                  background: `linear-gradient(135deg, #8C6671, #BA868E)`,
                }}
              >
                <span className="z-10">{emotie.nume}</span>
                <span className="absolute inset-0 bg-white opacity-10 group-hover:opacity-20 blur-md transition z-0" />
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default CumTeSimtiAzi;
